import React from "react";
import Logo from "../Assets/Images/Wordygift.png";

const Appbar = () => {
  return (
    <div className="w-full top-0 right-0 left-0 bg-[#C8266F] z-50 fixed px-[5vw] shadow-xl flex items-center justify-between mx-auto py-3">

      {/* Logo Section */}
      <section className="w-[200px] h-[150px] md:w-[150px] md:h-[100px] flex items-center justify-center">
        <img src={Logo} alt="logo" className="w-full h-full rounded-md object-cover" />
      </section>

      {/* Icons Section */}
      <main className="flex flex-wrap items-center justify-center md:justify-end space-x-5 md:space-x-10">
        <div className="flex flex-col items-center justify-center">
          <svg width="40" height="40" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <polyline points="20,50 40,70 80,30" stroke="#1BA9F4" strokeWidth="8" fill="none" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <h1 className="font-extrabold text-sm md:text-md text-white text-center">You Buy the Gift</h1>
        </div>

        <div className="flex flex-col items-center justify-center">
          <svg width="40" height="40" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <polyline points="20,50 40,70 80,30" stroke="#1BA9F4" strokeWidth="8" fill="none" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <h1 className="font-extrabold text-sm md:text-md text-white text-center">We Customise It</h1>
        </div>

        <div className="flex flex-col items-center justify-center">
          <svg width="40" height="40" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <polyline points="20,50 40,70 80,30" stroke="#1BA9F4" strokeWidth="8" fill="none" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <h1 className="font-extrabold text-sm md:text-md text-white text-center">They Receive Monthly Surprises</h1>
        </div>
      </main>
    </div>
  );
};

export default Appbar;
